<template>
        <div class=""  @click="gotopage" >
             <div class="avatar mb-1">
                <div  class="avatar-content">
                    <img :src="page.icon" alt="" width="50">
                </div>
            </div>
            <!-- <h2 class="fw-bolder">{{ page.status }}</h2> -->
            <p class="card-text">{{ page.name.slice(0,28) }}{{page.name.length>28 ? '...':''}}</p>
        </div>


</template>

<script>
import useDate from "@/services/utils/day";

export default {
    name: 'PageCard',

    props: ['page'],

    computed: {
        companyId () {
            return this.$route.params.companyId
        },
        moduleId () {
            return this.$route.params.moduleId
        },
        menuId () {
            return this.$route.params.menuId
        },
        pageId () {
            return this.page.id
        },
        basicParams () {
            return {
                companyId: this.companyId,
                moduleId: this.moduleId,
                menuId: this.menuId,
                pageId: this.pageId,
            }
        }
    },
    methods: {
        gotopage() {
            const date = useDate();

            if(this.page.route == 'inventory-list') {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams,
                        accountType: 'finished_goods'
                    }
                })
            }

            if(this.page.route == 'business-location') {
                this.$router.push({name: this.page.route ,
                    params: {
                        ...this.basicParams,
                        accountType: 'fg_warehouse'
                    }
                })
            }

            if (this.page.route === 'service-resources') {
              return this.$router.push({
                name: this.page.route,
                params: {
                  ...this.basicParams,
                  accountType: 'human_resources'
                }
              })
            }

          if (['sales-report-productwise', 'ipd-sales-collection-report'].includes(this.page.route)) {
              return this.$router.push({
                name: this.page.route,
                params: {
                  ...this.basicParams
                },
                query: {
                  date: date.currentDate()
                }
              })
            }

            if ([
              'pharmacy-bill-list',
              'opd-billing-list',
              'hospital-bill-list',
              'investigation-bill-list',
              'prescription-psc',
              'daily-cash-summary',
              'sales-report-general',
              'user-sales-summary',
              'pending-sample-laboratory',
              'single-service',
              'ipd-station',
              'ipd-register',
              'prescription-doctor',
              'money-receipt-statements',
              'user-collection-summary',
              'bill-manager',
              'pharmacy-billing',
              'my-visit-schedule',
              'visit-plan-list',
              'opd-billing-report',
              'supershop-pos-list'
            ].includes(this.page.route)) {
              return this.$router.push({
                name: this.page.route,
                params: {
                  ...this.basicParams
                },
                query: {
                    start: date.currentDate(),
                    end: date.currentDate()
                }
              })
            }

            this.$router.push({name: this.page.route ,
                params: {
                    ...this.basicParams,
                    accountType: 'asset'
                },
                query: {
                    start: this.getFirstDate(),
                    end: this.getLastDate(),
                    page: 1
                }
            })

        },

        getFirstDate () {
            const date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), 2).toISOString().split('T')[0];
        },
        getLastDate () {
            const date = new Date();
            return new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString().split('T')[0];
        }
    }
}
</script>

<style scoped>
  .avatar{
    width: 80px;
    height: 80px;
    border-radius: 10%;
    background-color: #FFFFFF;
  }
  .avatar img{
    border-radius: 0% !important;
  }

  .avatar-content{
    margin: auto !important;
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 15px;
    background-color: #f8f9fa;
    transition: transform 0.3s ease, background-color 0.3s ease;
  }
  .avatar-content:hover{
    width: 80px;
    height: 80px;
    background-color: #e7f3ff;
    transform: scale(1.15);
  }

</style>
